import { bindKey } from '@sama/micro-dash';
import {
  EventTrackingOptions,
  EventTrackingValue,
} from '../../team-apis/core/event-tracking';
import { ShellConnector } from '../../team-apis/core/shell-connector';

export interface TrackingEvent extends EventTrackingValue {
  id: string;
  bucket?: string;
  sub_bucket?: string;
}

export interface Tracker {
  track(event: TrackingEvent, options?: EventTrackingOptions): void;
}

export function buildTrackerFromShellConnector(
  shellConnector: ShellConnector,
): Tracker {
  return {
    track: bindKey(shellConnector, 'trackEvent'),
  };
}
